/**
 * 既存の行を選択する（currentPopupRowIdを設定）
 * @param rowId 選択する行のID
 * @param setCurrentPopupRowId currentPopupRowId設定関数
 */
export const selectExistingRow = (
  rowId: number,
  setCurrentPopupRowId?: React.Dispatch<React.SetStateAction<number | null>>
): void => {
  if (setCurrentPopupRowId) {
    setCurrentPopupRowId(rowId);
  }
};
